import { useTranslation } from "react-i18next";

import { TextboxFieldProps } from "capitalrx-components-2.0/lib/forms";
import { formValidation } from "capitalrx-utilities";

import { Textbox } from "@/basic/components";

export const ZipCodeTextbox = (props: TextboxFieldProps) => {
  const { t: translate } = useTranslation();
  const { validateZipcode } = formValidation;

  return <Textbox {...props} placeholder={translate("FORMS.zipCodeTextbox.zipCode")} validator={(val) => validateZipcode(val)} />;
};
